import React, { useState, useMemo } from "react";
import { COLORS } from "../../Constants/AppColors.js";
import { useTranslation } from "react-i18next";
import "../../Translation/i18n";
import i18n from "i18next";
import "./style.css";
import emailjs from "emailjs-com";
import Alert from "react-bootstrap/Alert";

function ContactUsPage() {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [comment, setComment] = useState("");
  const [isMailSent, setIsMailSent] = useState(true);

  const sendEmail = async () => {
    if (name === "") {
      alert(t("alert_name"));
      return;
    }

    if (phone === "") {
      alert(t("alert_Phone"));
      return;
    }

    if (email === "") {
      alert(t("alert_Email"));
      return;
    }

    if (subject === "") {
      alert(t("alert_Subject"));
      return;
    }

    if (comment === "") {
      alert(t("alert_Comment"));
      return;
    }

    try {
      setIsMailSent(false);
      const response = await emailjs.send(
        "service_zbqwcab",
        "template_pe0dw2m",
        { name, phone, subject, email, comment },
        "uZmSxyaCmc3iHdNAZ"
      );

      if (response.status === 200) {
        console.log(t("Successfully_sent_message"));
        alert(t("Successfully_sent_message"));
        setIsMailSent(true);
      }
    } catch (error) {
      console.error("Failed to send email. Error: ", error);
      alert("Failed to send email");
      setIsMailSent(true);
    }
  };

  const { t } = useTranslation();

  const [innerWidthState, setInnerWidthState] = useState(window.innerWidth);
  const [innerHeightState, setInnerHeightState] = useState(window.innerHeight);
  const [directionState, setDirectionState] = useState("ltr");

  React.useEffect(() => {
    if (i18n.language.includes("en")) {
      setDirectionState("ltr");
    } else {
      setDirectionState("ltr");
    }

    function handleResize() {
      console.log("resized to: ", window.innerWidth, "x", window.innerHeight);
      setInnerWidthState(window.innerWidth);
      setInnerHeightState(window.innerHeight);
    }

    window.addEventListener("resize", handleResize);

    console.log("i18n.locale: " + i18n.language);
  });

  const [hover, setHover] = useState(false);

  const handleMouseIn = () => {
    setHover(true);
  };

  const handleMouseOut = () => {
    setHover(false);
  };

  return (
    <div
      style={{
        // display: "flex",
        flexDirection: "row",
      }}
    >
      <div
        dir={directionState}
        style={{
          backgroundColor: "#F7F8F9",
          // width: innerWidthState + "px",
          height: "auto",
          backgroundSize: "cover",
          display: "flex",
          paddingBottom: 50,
          // overflowY: "scroll",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            // alignItems: "center",
            // justifyContent: "center",
            marginLeft: i18n.language.includes("en") ? 30 : 30,
            marginRight: i18n.language.includes("ar") ? 30 : 30,
            marginTop: 10,
            marginBottom: 10,
            width: innerWidthState / 2 + "px",
          }}
        >
          <label
            style={{
              color: COLORS.PageTitleFirstColor,
              fontSize: 35,
              textAlign: i18n.language.includes("en") ? "left" : "right",
              fontFamily: i18n.language.includes("en")
                ? "CI-Font-Title"
                : "CI-Font-Title-ar",
            }}
          >
            {t("contact_us_pt1")}{" "}
            <label
              style={{
                color: COLORS.PageTitleSecondColor,
                fontSize: 35,
                textAlign: i18n.language.includes("en") ? "left" : "right",
                fontFamily: i18n.language.includes("en")
                  ? "CI-Font-Title"
                  : "CI-Font-Title-ar",
              }}
            >
              {t("contact_us_pt2")}
            </label>
          </label>
          <div
            style={{
              flexDirection: "column",
              display: "flex",
              justifyContent: "left",
            }}
          >
            <label
              style={{
                color: "#3B62A8",
                fontSize: 15,
                marginTop: 10,
                textAlign: i18n.language.includes("en") ? "left" : "right",
                fontFamily: i18n.language.includes("en")
                  ? "CI-Font-Body-Text"
                  : "CI-Font-Body-Text-ar",
              }}
            >
              {t("Full_Name")}
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              style={{
                paddingTop: 5,
                paddingBottom: 5,
                borderRadius: 10,
                selectionColo: "white",
                borderColor: "#ffffff01",
                backgroundColor: "#EDF0F7",
                paddingLeft: 10,
                // color: "#3B62A8",
                fontSize: 15,
                textAlign: i18n.language.includes("en") ? "left" : "right",
                fontFamily: i18n.language.includes("en")
                  ? "CI-Font-Body-Text"
                  : "CI-Font-Body-Text-ar",
              }}
            />
            <label
              style={{
                color: "#3B62A8",
                fontSize: 15,
                marginTop: 10,
                textAlign: i18n.language.includes("en") ? "left" : "right",
                fontFamily: i18n.language.includes("en")
                  ? "CI-Font-Body-Text"
                  : "CI-Font-Body-Text-ar",
              }}
            >
              {t("phone")}
            </label>
            <input
              type="text"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              style={{
                paddingTop: 5,
                paddingBottom: 5,
                borderRadius: 10,
                selectionColo: "white",
                borderColor: "#ffffff01",
                backgroundColor: "#EDF0F7",
                paddingLeft: 10,
                // color: "#3B62A8",
                fontSize: 15,
                textAlign: i18n.language.includes("en") ? "left" : "right",
                fontFamily: i18n.language.includes("en")
                  ? "CI-Font-Body-Text"
                  : "CI-Font-Body-Text-ar",
              }}
            />
            <label
              style={{
                color: "#3B62A8",
                fontSize: 15,
                marginTop: 10,
                textAlign: i18n.language.includes("en") ? "left" : "right",
                fontFamily: i18n.language.includes("en")
                  ? "CI-Font-Body-Text"
                  : "CI-Font-Body-Text-ar",
              }}
            >
              {t("Email")}
            </label>
            <input
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{
                paddingTop: 5,
                paddingBottom: 5,
                borderRadius: 10,
                selectionColo: "white",
                borderColor: "#ffffff01",
                backgroundColor: "#EDF0F7",
                paddingLeft: 10,
                // color: "#3B62A8",
                fontSize: 15,
                textAlign: i18n.language.includes("en") ? "left" : "right",
                fontFamily: i18n.language.includes("en")
                  ? "CI-Font-Body-Text"
                  : "CI-Font-Body-Text-ar",
              }}
            />
            <label
              style={{
                color: "#3B62A8",
                fontSize: 15,
                marginTop: 10,
                textAlign: i18n.language.includes("en") ? "left" : "right",
                fontFamily: i18n.language.includes("en")
                  ? "CI-Font-Body-Text"
                  : "CI-Font-Body-Text-ar",
              }}
            >
              {t("Subject")}
            </label>
            <input
              type="text"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              style={{
                paddingTop: 5,
                paddingBottom: 5,
                borderRadius: 10,
                selectionColor: "white",
                borderColor: "#ffffff01",
                backgroundColor: "#EDF0F7",
                paddingLeft: 10,
                // color: "#3B62A8",
                fontSize: 15,
                textAlign: i18n.language.includes("en") ? "left" : "right",
                fontFamily: i18n.language.includes("en")
                  ? "CI-Font-Body-Text"
                  : "CI-Font-Body-Text-ar",
              }}
            />
            <label
              style={{
                color: "#3B62A8",
                fontSize: 15,
                marginTop: 10,
                textAlign: i18n.language.includes("en") ? "left" : "right",
                fontFamily: i18n.language.includes("en")
                  ? "CI-Font-Body-Text"
                  : "CI-Font-Body-Text-ar",
              }}
            >
              {t("how_help_you")}
            </label>
            <textarea
              type="text"
              rows={4}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              style={{
                paddingTop: 5,
                paddingBottom: 5,
                borderRadius: 10,
                selectionColor: "white",
                borderColor: "#ffffff01",
                backgroundColor: "#EDF0F7",
                paddingLeft: 10,
                // color: "#3B62A8",
                fontSize: 15,
                textAlign: i18n.language.includes("en") ? "left" : "right",
                fontFamily: i18n.language.includes("en")
                  ? "CI-Font-Body-Text"
                  : "CI-Font-Body-Text-ar",
              }}
            />
            <div
              style={{
                // backgroundColor: "#cf0",
                justifyContent: i18n.language.includes("en") ? "left" : "right",
                display: "flex",
                marginTop: -2,
              }}
            >
              {i18n.language.includes("en") ? (
                <button
                  style={{
                    marginTop: 5,
                    borderColor: "#ffffff01",
                    // borderWidth: 0,
                    // padding: 0,
                    alignItems: "center",
                    justifyContent: i18n.language.includes("en")
                      ? "left"
                      : "right",
                  }}
                  onMouseOver={handleMouseIn}
                  onMouseOut={handleMouseOut}
                  onClick={() => {
                    if (isMailSent) sendEmail();
                  }}
                  class="shape"
                >
                  <text
                    style={{
                      position: "relative",
                      fontFamily: i18n.language.includes("en")
                        ? "CI-Font-Body-Text"
                        : "CI-Font-Body-Text-ar",
                      fontSize: 13,
                      marginLeft: i18n.language.includes("en") ? -30 : 0,
                      marginRight: i18n.language.includes("ar") ? -30 : 0,
                      top: "-2.5px",
                    }}
                  >
                    {t("submit_btn")}
                  </text>
                  {/* <img
                src={
                  i18n.language.includes("en")
                    ? hover
                      ? require("../../assets/left_submit_hover_btn.svg")
                          .default
                      : require("../../assets/left_submit_btn.svg").default
                    : hover
                    ? require("../../assets/right_submit_hover_btn.svg").default
                    : require("../../assets/right_submit_btn.svg").default
                }
                style={{
                  position: "absolute",
                  bottom: i18n.language.includes("en") ? 30 : 30,
                  left: i18n.language.includes("en") ? 25 : null,
                  right: i18n.language.includes("ar")
                    ? innerWidthState / 2 + 25 + "px"
                    : null,
                }}
                width="100"
                height="25"
                alt=""
              /> */}
                </button>
              ) : (
                <button
                  style={{
                    marginTop: 5,
                    borderColor: "#ffffff01",
                    // borderWidth: 0,
                    // padding: 0,
                    alignItems: "center",
                    justifyContent: i18n.language.includes("en")
                      ? "left"
                      : "right",
                    // backgroundColor:'#cf0'
                  }}
                  onMouseOver={handleMouseIn}
                  onMouseOut={handleMouseOut}
                  onClick={() => {
                    if (isMailSent) sendEmail();
                  }}
                  class="shape_ar"
                >
                  <text
                    style={{
                      position: "relative",
                      fontFamily: i18n.language.includes("en")
                        ? "CI-Font-Body-Text"
                        : "CI-Font-Body-Text-ar",
                      fontSize: 13,
                      marginLeft: i18n.language.includes("en") ? -30 : 0,
                      marginRight: i18n.language.includes("ar") ? -30 : 0,
                      top: "-2.5px",
                    }}
                  >
                    {t("submit_btn")}
                  </text>
                  {/* <img
                src={
                  i18n.language.includes("en")
                    ? hover
                      ? require("../../assets/left_submit_hover_btn.svg")
                          .default
                      : require("../../assets/left_submit_btn.svg").default
                    : hover
                    ? require("../../assets/right_submit_hover_btn.svg").default
                    : require("../../assets/right_submit_btn.svg").default
                }
                style={{
                  position: "absolute",
                  bottom: i18n.language.includes("en") ? 30 : 30,
                  left: i18n.language.includes("en") ? 25 : null,
                  right: i18n.language.includes("ar")
                    ? innerWidthState / 2 + 25 + "px"
                    : null,
                }}
                width="100"
                height="25"
                alt=""
              /> */}
                </button>
              )}
            </div>
          </div>
        </div>

        <img
          src={require("../../assets/Contact_Us_image.png")}
          alt="logo"
          style={{
            width: innerWidthState / 2 + "px",
            height: innerHeightState - 145 + "px",
            // borderTopLeftRadius: 20,
            // borderBottomLeftRadius: 20,
          }}
        />
      </div>
      <div
        dir={directionState}
        style={{
          backgroundColor: "#F7F8F9",
          height: "auto",
          backgroundSize: "cover",
          display: "flex",
          paddingBottom: 50,
          flexDirection: "row",
        }}
      >
        <img
          src={
            i18n.language.includes("en")
              ? require("../../assets/blur_bg_left.png")
              : require("../../assets/blur_bg_right.png")
          }
          alt="logo"
          class="img"
          style={{
            width: innerWidthState / 2 + "px",
            height: "400px",
            borderTopLeftRadius: 20,
            borderBottomLeftRadius: 20,
            marginLeft: 30,
          }}
        />

        <img
          src={require("../../assets/map_image.png")}
          alt="logo"
          class="fluid"
          style={{
            width: innerWidthState / 2 + "px",
            height: "400px",
            backgroundColor: "#000",
            borderTopRightRadius: 20,
            borderBottomRightRadius: 20,
            marginRight: 30,
            resize: "cover",
          }}
        />
      </div>
    </div>
  );
}

export default ContactUsPage;
